<div class="reflection-container">
  <h1 id="pastReflectionsTitle">Past Reflections</h1>
  <div
    class="reflection-inner-container"
    *ngIf="reflections?.status === status.done && reflections?.data as reflection; else loading">
    <div class="reflection-header">
      <button
        #reflectionBack
        class="container-caret left"
        *ngIf="reflection.hasMoreQuestions; else placeholder"
        (click)="onBack(reflection.hasMoreQuestions)"
        aria-label="Previous reflection">
        <svg-icon src="/assets/icons/chevron-left-nocircle.svg"></svg-icon>
      </button>
      <div id="date" class="reflection-header-date page-item-center">{{ reflection.date | date : 'fullDate' }}</div>
      <button
        #reflectionNext
        class="container-caret right"
        *ngIf="index !== 0; else placeholder"
        (click)="onForward()"
        aria-label="Next reflection">
        <svg-icon src="/assets/icons/chevron-right-nocircle.svg"></svg-icon>
      </button>
    </div>
    <div class="reflections-container" *ngIf="reflection.availableDates">
      <div class="no-reflections" *ngIf="reflections.status === status.done && !hasReflections">
        <h3 class="no-reflections no-reflections-header">Nothing here yet!</h3>
        <p class="no-reflections no-reflections-description">Complete a reflection to see your responses here.</p>
      </div>
      <div class="reflection-nocontent" *ngIf="!reflection.isLoading && reflection.availableDates[index] === null">
        <span>No Available Data</span>
      </div>
      <ng-container *ngIf="hasReflections && questionSets">
        <div class="reflection-content" *ngFor="let questionSet of questionSets">
          <kp-reflection-question-set [questionSet]="questionSet"></kp-reflection-question-set>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loading>
  <kp-shimmer class="date-shimmer"></kp-shimmer>
  <kp-shimmer class="past-reflection-shimmer"></kp-shimmer>
  <kp-shimmer class="past-reflection-shimmer"></kp-shimmer>
  <kp-shimmer class="past-reflection-shimmer"></kp-shimmer>
  <kp-shimmer class="past-reflection-shimmer"></kp-shimmer>
</ng-template>

<ng-template #placeholder>
  <div class="container-caret placeholder"></div>
</ng-template>
